import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useCanAnnotateCentralizedPublicClip } from "~/components/Annotations/hooks/useCanAnnotateCentralizedPublicClip";
import { ImageVisualizer } from "~/components/AssetModal/Visualizer/ImageVisualizer/ImageVisualizer";
export const PublicImageVisualizer = /*#__PURE__*/ memo(()=>{
    const { canEditAnnotation } = useCanAnnotateCentralizedPublicClip();
    return /*#__PURE__*/ _jsx(ImageVisualizer, {
        canAnnotateClip: canEditAnnotation
    });
});
PublicImageVisualizer.displayName = "PublicImageVisualizer";
